import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { UserPlus, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { API_URL as API } from '../config';
import { ConnectButton } from './ConnectButton';
import { FollowButton } from './FollowButton';

export function PeopleYouMayKnow({ limit = 4, className }) {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchSuggestions = useCallback(async () => {
        try {
            const response = await axios.get(`${API}/recommendations?limit=${limit}`);
            setSuggestions(response.data);
        } catch (error) {
            console.error('Failed to fetch recommendations:', error);
        } finally {
            setLoading(false);
        }
    }, [limit]);

    useEffect(() => {
        fetchSuggestions();
    }, [fetchSuggestions]);

    if (loading) {
        return (
            <div className={`space-y-4 animate-pulse ${className}`}>
                {[...Array(limit)].map((_, i) => (
                    <div key={i} className="h-20 rounded-xl" style={{ backgroundColor: 'var(--hover-overlay)' }} />
                ))}
            </div>
        );
    }

    if (suggestions.length === 0) return null;

    return (
        <div className={className}>
            <div className="flex items-center justify-between mb-4">
                <h3 className="font-lexend font-semibold" style={{ color: 'var(--text-primary)' }}>People You May Know</h3>
                <Link to="/community" className="text-xs text-inclusion-gold hover:underline flex items-center">
                    See All <ChevronRight className="w-3 h-3 ml-1" />
                </Link>
            </div>
            <div className="space-y-3">
                {suggestions.map((person) => (
                    <div key={person.id} className="rounded-xl border p-4 flex items-center gap-3 transition-colors" style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border-subtle)' }}>
                        <div className="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center font-bold" style={{ backgroundColor: 'var(--hover-overlay)', color: 'var(--text-muted)' }}>
                            {person.name?.charAt(0)}
                        </div>
                        <div className="flex-grow min-w-0">
                            <h4 className="text-sm font-medium truncate" style={{ color: 'var(--text-primary)' }}>{person.name}</h4>
                            <p className="text-xs truncate" style={{ color: 'var(--text-muted)' }}>{person.location}</p>
                        </div>
                        <div className="flex flex-wrap items-center justify-end gap-2 min-w-0">
                            <FollowButton userId={person.id} className="h-8 px-2 text-[10px] flex-1 min-w-[85px] whitespace-nowrap" />
                            <ConnectButton userId={person.id} className="h-8 px-2 text-[10px] flex-1 min-w-[85px] whitespace-nowrap" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
